<script setup lang="ts">
import { i18n } from '@/i18n'
import emptyCollection from '@/assets/emptyCollection.png'

const t = i18n.global.t
</script>

<template>
  <div class="flex flex-col items-center max-w-[810px] mx-auto my-32">
    <img :src="emptyCollection" width="234" height="114" />
    <h1 class="text-2xl mt-8 mb-4">{{ t('emptyCollectionHeading') }}</h1>
    <p class="text-xl/10 font-extralight text-center">{{ t('emptyCollectionText') }}</p>
  </div>
</template>

<style scoped></style>
